/** @format */

import React from 'react';
import Alert from '@mui/material/Alert';
import { Snackbar } from '@mui/material';

function AlertSnack(props) {
  return <Alert elevation={6} variant="filled" {...props} />;
}

const SnackbarFp = (props) => {
  const { data, open, setOpenSnack } = props;

  const handleClose = () => {
    setOpenSnack(false);
  };

  return (
    <>
      <Snackbar
        open={open}
        autoHideDuration={3500}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <AlertSnack onClose={handleClose} severity={data.action}>
          {data.txt}
        </AlertSnack>
      </Snackbar>
    </>
  );
};

export default SnackbarFp;
